import React, { useState, useEffect, useContext } from "react";
import Navbar from "./Navbar";
import { NavbarContext, NavigateContext } from "../App";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { buildAccountJsonBody, buildProsArray, buildOrgsArray, accountNameLoaded } from "../utils/accountBody";

var baseUrl = "https://cognitunerdev.azurewebsites.net";

var org = localStorage.getItem("org");

var token = localStorage.getItem("token");
var createOrgClient = localStorage.getItem("createOrgClient");
var userLanguage = localStorage.getItem("userLanguage");
var userId = localStorage.getItem("userId");

var showClients = null;

if (userId !== null) {
  showClients = localStorage.getItem("showClients_" + userId);
}

var selectedClient = false;
var clientSearched = false;

function checkEndDate(endDate) {
  if (endDate === null) {
    return true;
  }

  var dateNowUtc = new Date().toUTCString();
  var dateNow = new Date(dateNowUtc).valueOf();
  var endDateNow = new Date(endDate).valueOf();

  if (dateNow > endDateNow) {
    return false;
  }

  return true;
}

Date.prototype.addDays = function (days) {
  let date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

function checkDate(date) {
  if (date.split("T") === undefined) {
    return date;
  }
  else {
    if (date.split("T")[1].startsWith("22")) {
      var newDateRaw = new Date(date.split("T")[0]);

      newDateRaw = newDateRaw.addDays(1);

      var newDateYear = newDateRaw.getFullYear();
      var newDateMonth = newDateRaw.getMonth() + 1;
      var newDateDay = newDateRaw.getDate();

      if (newDateDay >= 1 && newDateDay <= 9) {
        newDateDay = "0" + newDateDay;
      }

      if (newDateMonth >= 1 && newDateMonth <= 9) {
        newDateMonth = "0" + newDateMonth;
      }

      var newDate = newDateYear + "-" + newDateMonth + "-" + newDateDay;

      return newDate;
    }

    return date.split("T")[0];
  }
}

function navigateToClientSelection(navigate) {
  navigate("/clientselection");
}

function navigateToMenu(navigate) {
  navigate("/menu");
}

function navigateToOrganisation(navigate) {
  navigate("/organisation");
}

function editClient(navigate, setNavigateContext) {
  localStorage.setItem("editClient", true);
  setNavigateContext(true);
  navigate("/createoreditclient");
}

function deleteClient(navigate, setNavigateContext) {
  localStorage.setItem("deleteClient", true);
  setNavigateContext(true);
  navigate("/createoreditclient");
}

function assignPros(navigate, setNavigateContext) {
  setNavigateContext(true);
  navigate("/assignpros");
}

function searchResultRecipe(navigate, setNavigateContext) {
  setNavigateContext(true);
  navigate("/resultByRecipe");
}

function searchResultGame(navigate, setNavigateContext) {
  setNavigateContext(true);
  navigate("/resultByGame");
}

function reloadPage() {
  window.location.reload();
}

function checkClient(event, setNavigateContext) {
  setNavigateContext(true);

  var clientElements = document.getElementsByClassName("ClientSelection-ClientLink");

  for (let i = 0; i < clientElements.length; i++) {
    if (clientElements[i].style.color === "blue") {
      localStorage.setItem("selectedClientName", clientElements[i].innerHTML);
      localStorage.setItem("selectedClientEmail", clientElements[i].getAttribute("data-user-email"));
      localStorage.setItem("selectedClientUsername", clientElements[i].getAttribute("data-user-username"));
      localStorage.setItem("selectedClientUserId", clientElements[i].getAttribute("data-user-id"));
      localStorage.setItem("selectedClientLocale", clientElements[i].getAttribute("data-user-locale"));
      localStorage.setItem("selectedClientOrgs", clientElements[i].getAttribute("data-user-orgs"));
      localStorage.setItem("clientActivated", clientElements[i].getAttribute("data-user-activated"));
      localStorage.setItem("selectedClientTwoStepVerified", clientElements[i].getAttribute("data-user-twostep"));
      localStorage.setItem("selectedClientDeviceLock", clientElements[i].getAttribute("data-user-device-lock"));

      var settings = clientElements[i].getAttribute("data-user-settings");

      if (settings !== null && settings.substring(settings.indexOf("[") + 1, settings.indexOf("[") + 2) === '"') {
        localStorage.setItem("selectedClientSettingsPros", settings.substring(settings.indexOf("[") + 1, settings.indexOf("]")).replaceAll('"', ""));
      }

      var restrictedRecipesIndex = settings.indexOf("RestrictToRecipes");

      if (settings !== null && restrictedRecipesIndex !== -1) {
        localStorage.setItem("selectedClientRestrictToRecipes", settings.substring(restrictedRecipesIndex).split(":")[1].split(",")[0]);
      }
      else {
        localStorage.setItem("selectedClientRestrictToRecipes", false);
      }

      break;
    }
  }
}

function filterClients(event) {
  return event.role === "Client";
}

function returnToLogin() {
  window.location.replace(window.location.origin);
}

const ClientSelection = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (userLanguage !== null) {
      i18n.changeLanguage(userLanguage);
    }
  }, [i18n]);

  if (createOrgClient === "true") {
    org = localStorage.getItem("selectedOrgId");
  }

  const userEditedOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_user_edited")}</h1>
        <button className="confirmButton" onClick={() => {reloadPage(); onClose();}}>Ok</button>
      </div>,
    closeOnClickOutside: false,
    willUnmount: () => {}
  }

  const userEditFailedOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_user_edit_failed")}</h1>
        <button className="confirmButton" onClick={onClose}>Ok</button>
      </div>,
    willUnmount: () => {}
  }

  const resetEmailSentOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_reset_email_sent")}</h1>
        <button className="confirmButton" onClick={onClose}>Ok</button>
      </div>,
    willUnmount: () => {}
  }

  const resetEmailFailedOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_failed_to_send_reset_email")}</h1>
        <button className="confirmButton" onClick={onClose}>Ok</button>
      </div>,
    willUnmount: () => {}
  }

  const tokenExpiredOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_token_expired")}</h1>
        <button className="confirmButton" onClick={removeTokenAndReturnToLogin}>{t("local_return_to_login")}</button>
      </div>,
    closeOnClickOutside: false,
    willUnmount: () => {}
  }

  const wrongUserDataOptions = {
    title: 'Title',
    message: 'Message',
    buttons: [
      {
        label: 'Yes',
        onClick: () => alert('Click Yes')
      },
      {
        label: 'No',
        onClick: () => alert('Click No')
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ title, message, onClose }) =>
      <div className='custom-ui'>
        <h1>{t("local_wrong_user_data")}</h1>
        <button className="confirmButton" onClick={removeTokenAndReturnToLogin}>{t("local_return_to_login")}</button>
      </div>,
    closeOnClickOutside: false,
    willUnmount: () => {}
  }

  if (token === null || token === undefined || !token) {
    const tokenOptions = {
      title: 'Title',
      message: 'Message',
      buttons: [
        {
          label: 'Yes',
          onClick: () => alert('Click Yes')
        },
        {
          label: 'No',
          onClick: () => alert('Click No')
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ title, message, onClose }) =>
        <div className='custom-ui'>
          <h1>{t("local_token_not_found")}</h1>
          <button className="confirmButton" onClick={returnToLogin}>{t("local_return_to_login")}</button>
        </div>,
      closeOnClickOutside: false,
      willUnmount: () => {}
    }

    confirmAlert(tokenOptions);
  }

  async function setTwoStepFalse() {
    if (userId !== undefined && userId !== null && token !== undefined && token !== null) {
      // Skip the write if the account name never loaded — otherwise full_name
      // goes out as the string "null" and overwrites the real name.
      if (!accountNameLoaded(username)) {
        return;
      }

      document.getElementById("overlay").style.display = "block";

      var jsonBody = buildAccountJsonBody({
        user_id: userId,
        twostep: false,
        email: userEmail,
        full_name: username,
        expires: (userExpires === "null" || userExpires === null) ? null : userExpires,
        locale: userLanguage.toUpperCase(),
        role: role,
        active: true,
        settings: JSON.stringify({
          RestrictToRecipes: false,
          Pros: buildProsArray(userId, userSettingsIds),
        }),
        orgs: buildOrgsArray(org, orgs),
      });

      try {
        const response = await fetch(baseUrl + "/api/v1/account/" + userId, {
          method: "POST",
          headers: { "Authorization": "Bearer " + token, "Content-Type": 'application/json' },
          body: jsonBody,
        });

        console.log(response);

        if (response.status === 200) {
        }
        else if (response.status === 500) {
          const twoStepVerifyFailedOptions2 = {
            title: 'Title',
            message: 'Message',
            buttons: [
              {
                label: 'Yes',
                onClick: () => alert('Click Yes')
              },
              {
                label: 'No',
                onClick: () => alert('Click No')
              }
            ],
            childrenElement: () => <div />,
            customUI: ({ title, message, onClose }) =>
              <div className='custom-ui'>
                <h1>{t("local_two_step_verify_failed")}</h1>
                <button className="confirmButton" onClick={onClose}>Ok</button>
              </div>,
            closeOnClickOutside: false,
            willUnmount: () => {}
          }

          confirmAlert(twoStepVerifyFailedOptions2);
        }
        else {
          const data = await response.json();

          if (data.Message !== null && data.Message !== undefined) {
            var errorMessage = data.Message;

            if (data.Message === "Error_EmailExists") {
              errorMessage = t("local_api_result_error_email_exists");
            }
            else if (data.Message === "Error_UserLimitReached") {
              errorMessage = t("local_api_result_error_user_limit_reached");
            }
            else if (data.Message === "Error_UserNameExists") {
              errorMessage = t("local_api_result_error_user_name_exists");
            }
            else if (data.Message === "Error_Internal") {
              errorMessage = t("local_api_result_error_internal");
            }
            else if (data.Message === "Error_ResourceNotFound") {
              errorMessage = t("local_api_result_error_resource_not_found");
            }
            else if (data.Message === "Error_UnauthorizedAccess") {
              errorMessage = t("local_api_result_error_unauthorized_access");
            }
            else if (data.Message === "Error_InvalidBody") {
              errorMessage = t("local_api_result_error_invalid_body");
            }
            else if (data.Message === "Error_ValidationFailed") {
              errorMessage = t("local_api_result_error_validation_failed");
            }
            else if (data.Message === "Error_InvalidRequest") {
              errorMessage = t("local_api_result_error_invalid_request");
            }
            else if (data.Message === "Error_InsufficientPermissions") {
              errorMessage = t("local_api_result_error_insufficient_permissions");
            }
            else if (data.Message === "Error_InvalidEmail") {
              errorMessage = t("local_api_result_error_invalid_email");
            }
            else if (data.Message === "Error_AlreadyExists") {
              errorMessage = t("local_api_result_error_already_exists");
            }
            else if (data.Message === "Unknown") {
              errorMessage = t("local_api_result_unknown");
            }

            if (data.Message === "AuthError_InvalidAccessToken") {
              confirmAlert(tokenExpiredOptions);
            }
            else {
              const userCreationFailedOptions = {
                title: 'Title',
                message: 'Message',
                buttons: [
                  {
                    label: 'Yes',
                    onClick: () => alert('Click Yes')
                  },
                  {
                    label: 'No',
                    onClick: () => alert('Click No')
                  }
                ],
                childrenElement: () => <div />,
                customUI: ({ title, message, onClose }) =>
                  <div className='custom-ui'>
                    <h1>{errorMessage}</h1>
                    <button className="confirmButton" onClick={onClose}>Ok</button>
                  </div>,
                willUnmount: () => {}
              }

              confirmAlert(userCreationFailedOptions);
            }

          }
        }

        document.getElementById("overlay").style.display = "none";

      } catch (err) {
        document.getElementById("overlay").style.display = "none";

        const userCreationFailedOptions2 = {
          title: 'Title',
          message: 'Message',
          buttons: [
            {
              label: 'Yes',
              onClick: () => alert('Click Yes')
            },
            {
              label: 'No',
              onClick: () => alert('Click No')
            }
          ],
          childrenElement: () => <div />,
          customUI: ({ title, message, onClose }) =>
            <div className='custom-ui'>
              <h1>{t("local_user_edit_failed2")} {err}</h1>
              <button className="confirmButton" onClick={onClose}>Ok</button>
            </div>,
          willUnmount: () => {}
        }

        confirmAlert(userCreationFailedOptions2);
      }
    }

  }

  async function removeTokenAndReturnToLogin() {
    await setTwoStepFalse();
    localStorage.clear();
    localStorage.setItem("userLanguage", userLanguage);
    sessionStorage.clear();
    window.location.replace(window.location.origin);
  }

  const { navigateContext, setNavigateContext } = useContext(NavigateContext);

  window.onpopstate=function() {
    setNavigateContext(false);
    window.location.reload();
  }

  if (navigateContext !== true) {
    if (clientSearched === false) {
      localStorage.removeItem("selectedClientName");
      localStorage.removeItem("selectedClientEmail");
      localStorage.removeItem("selectedClientUsername");
      localStorage.removeItem("selectedClientUserId");
      localStorage.removeItem("selectedClientLocale");
      localStorage.removeItem("selectedClientExpires");
      localStorage.removeItem("selectedClientSettingsPros");
      localStorage.removeItem("selectedClientRestrictToRecipes");
      localStorage.removeItem("selectedClientTwoStepVerified");
    }

    localStorage.removeItem("templateMenuNavigate");
    localStorage.removeItem("navigateFromClient");
    localStorage.removeItem("editClient");
    localStorage.removeItem("deleteClient");
  }

  localStorage.removeItem("selectedRecipeId");
  localStorage.removeItem("selectedRecipeType");
  localStorage.removeItem("selectedRecipeEndDate");
  localStorage.removeItem("selectedRecipeStartDate");
  localStorage.removeItem("selectedRecipeName");
  localStorage.removeItem("templateRecipeId");

  if (navigateContext === true) {
    window.location.reload();
    setNavigateContext(false);
  }

  const [clientName, setClientName] = useState(null);
  const [clientUserId, setClientUserId] = useState(null);
  const [clientEmail, setClientEmail] = useState(null);
  const [clientUsername, setClientUsername] = useState(null);
  const [clientEulaAccepted, setClientEulaAccepted] = useState(t("local_not_activated"));
  const [clientExpires, setClientExpires] = useState(t("local_unlimited"));
  const [clientActivated, setClientActivated] = useState(null);
  const [clientDeviceLock, setClientDeviceLock] = useState(null);

  //const [clientFirstName, setClientFirstName] = useState("None");
  //const [clientLastName, setClientLastName] = useState("None");

  async function confirmDeviceLockRelease() {
    const confirmDeviceLockReleaseOptions = {
      title: 'Title',
      message: 'Message',
      buttons: [
        {
          label: 'Yes',
          onClick: () => alert('Click Yes')
        },
        {
          label: 'No',
          onClick: () => alert('Click No')
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ title, message, onClose }) =>
        <div className='custom-ui'>
          <h1>{t("local_confirm_release_device_lock")}</h1>
          <button className="confirmButton" onClick={() => { releaseDeviceLock(); onClose();}}>{t("local_confirm")}</button>
          <button className="closeButton" onClick={onClose}>{t("local_cancel")}</button>
        </div>,
      willUnmount: () => {}
    }

    confirmAlert(confirmDeviceLockReleaseOptions);
  }

  async function releaseDeviceLock() {
    document.getElementById("overlay").style.display = "block";

    var fetchUrl = baseUrl + "/api/v1/account/" + clientUserId + "/release-device-lock";

    try {
      const response = await fetch(fetchUrl,
      {
        headers: { "Authorization": "Bearer " + token,
         "Auth-ForceAdminClientAccess": "1" }
      });

      console.log(response);

      if (response.status === 200) {
        confirmAlert(userEditedOptions);
      }
      else if (response.status === 500) {
        confirmAlert(userEditFailedOptions);
      }
      else {
        const data = await response.json();

        if (data.Message !== null && data.Message !== undefined) {
          var errorMessage = data.Message;

          if (data.Message === "Error_EmailExists") {
            errorMessage = t("local_api_result_error_email_exists");
          }
          else if (data.Message === "Error_UserLimitReached") {
            errorMessage = t("local_api_result_error_user_limit_reached");
          }
          else if (data.Message === "Error_UserNameExists") {
            errorMessage = t("local_api_result_error_user_name_exists");
          }
          else if (data.Message === "Error_Internal") {
            errorMessage = t("local_api_result_error_internal");
          }
          else if (data.Message === "Error_ResourceNotFound") {
            errorMessage = t("local_api_result_error_resource_not_found");
          }
          else if (data.Message === "Error_UnauthorizedAccess") {
            errorMessage = t("local_api_result_error_unauthorized_access");
          }
          else if (data.Message === "Error_InvalidBody") {
            errorMessage = t("local_api_result_error_invalid_body");
          }
          else if (data.Message === "Error_ValidationFailed") {
            errorMessage = t("local_api_result_error_validation_failed");
          }
          else if (data.Message === "Error_InvalidRequest") {
            errorMessage = t("local_api_result_error_invalid_request");
          }
          else if (data.Message === "Error_InsufficientPermissions") {
            errorMessage = t("local_api_result_error_insufficient_permissions");
          }
          else if (data.Message === "Error_InvalidEmail") {
            errorMessage = t("local_api_result_error_invalid_email");
          }
          else if (data.Message === "Error_AlreadyExists") {
            errorMessage = t("local_api_result_error_already_exists");
          }
          else if (data.Message === "Unknown") {
            errorMessage = t("local_api_result_unknown");
          }

          if (data.Message === "AuthError_InvalidAccessToken") {
            confirmAlert(tokenExpiredOptions);
          }
          else {
            const userCreationFailedOptions = {
              title: 'Title',
              message: 'Message',
              buttons: [
                {
                  label: 'Yes',
                  onClick: () => alert('Click Yes')
                },
                {
                  label: 'No',
                  onClick: () => alert('Click No')
                }
              ],
              childrenElement: () => <div />,
              customUI: ({ title, message, onClose }) =>
                <div className='custom-ui'>
                  <h1>{errorMessage}</h1>
                  <button className="confirmButton" onClick={onClose}>Ok</button>
                </div>,
              willUnmount: () => {}
            }

            confirmAlert(userCreationFailedOptions);
          }

        }
      }

      document.getElementById("overlay").style.display = "none";

    } catch (err) {
      document.getElementById("overlay").style.display = "none";

      const userCreationFailedOptions2 = {
        title: 'Title',
        message: 'Message',
        buttons: [
          {
            label: 'Yes',
            onClick: () => alert('Click Yes')
          },
          {
            label: 'No',
            onClick: () => alert('Click No')
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ title, message, onClose }) =>
          <div className='custom-ui'>
            <h1>{t("local_user_edit_failed2")} {err}</h1>
            <button className="confirmButton" onClick={onClose}>Ok</button>
          </div>,
        willUnmount: () => {}
      }

      confirmAlert(userCreationFailedOptions2);
    }
  }

  function saveClient(event) {
    var clientFullName = event.currentTarget.innerHTML;

    clientSearched = true;

    localStorage.setItem("clientName", clientFullName);
    localStorage.setItem("clientUserId", event.currentTarget.getAttribute("data-user-id"));
    localStorage.setItem("clientEmail", event.currentTarget.getAttribute("data-user-email"));
    localStorage.setItem("clientActivated", event.currentTarget.getAttribute("data-user-activated"));

    setClientName(clientFullName);
    setClientUserId(event.currentTarget.getAttribute("data-user-id"));

    if ( event.currentTarget.getAttribute("data-user-email") !== null ) {
      setClientEmail(event.currentTarget.getAttribute("data-user-email"));
    }
    else {
      setClientUsername(event.currentTarget.getAttribute("data-user-username"));
      setClientEmail(null);
    }

    setClientActivated(event.currentTarget.getAttribute("data-user-activated"));
    setClientDeviceLock(event.currentTarget.getAttribute("data-user-device-lock"));
    localStorage.setItem("selectedClientDeviceLock", event.currentTarget.getAttribute("data-user-device-lock"));

    localStorage.setItem("selectedClientName", clientFullName);
    localStorage.setItem("selectedClientEmail", event.currentTarget.getAttribute("data-user-email"));
    localStorage.setItem("selectedClientUsername", event.currentTarget.getAttribute("data-user-username"));
    localStorage.setItem("selectedClientUserId", event.currentTarget.getAttribute("data-user-id"));
    localStorage.setItem("selectedClientLocale", event.currentTarget.getAttribute("data-user-locale"));
    localStorage.setItem("selectedClientOrgs", event.currentTarget.getAttribute("data-user-orgs"));
    localStorage.setItem("selectedClientTwoStepVerified", event.currentTarget.getAttribute("data-user-twostep"));

    var settings = event.currentTarget.getAttribute("data-user-settings");

    if (settings !== null && settings.substring(settings.indexOf("[") + 1, settings.indexOf("[") + 2) === '"') {
      localStorage.setItem("selectedClientSettingsPros", settings.substring(settings.indexOf("[") + 1, settings.indexOf("]")).replaceAll('"', ""));
    }

    var restrictedRecipesIndex = settings.indexOf("RestrictToRecipes");

    if (settings !== null && restrictedRecipesIndex !== -1) {
      localStorage.setItem("selectedClientRestrictToRecipes", settings.substring(restrictedRecipesIndex).split(":")[1].split(",")[0]);
    }
    else {
      localStorage.setItem("selectedClientRestrictToRecipes", false);
    }

    if (event.currentTarget.getAttribute("data-user-eula") !== null) {
      localStorage.setItem("clientEulaAccepted", event.currentTarget.getAttribute("data-user-eula").split("T")[0]);
      setClientEulaAccepted(event.currentTarget.getAttribute("data-user-eula").split("T")[0]);
    }
    else {
      localStorage.setItem("clientEulaAccepted", t("local_not_activated"));
      setClientEulaAccepted(t("local_not_activated"));
    }

    if (event.currentTarget.getAttribute("data-user-expires") !== null) {
      localStorage.setItem("clientExpires", checkDate(event.currentTarget.getAttribute("data-user-expires")));
      setClientExpires(checkDate(event.currentTarget.getAttribute("data-user-expires")));
      localStorage.setItem("selectedClientExpires", checkDate(event.currentTarget.getAttribute("data-user-expires")));
    }
    else {
      localStorage.setItem("clientExpires", t("local_unlimited"));
      setClientExpires(t("local_unlimited"));
    }

    /*var whiteSpaceLocation = clientFullName.search(/\s/);

    if (whiteSpaceLocation !== -1) {
      var lastSpaceIndex = clientFullName.lastIndexOf(" ");

      setClientFirstName(clientFullName.split(" ")[0]);
      setClientLastName(clientFullName.substr(lastSpaceIndex));
    }
    else {
      setClientFirstName(clientFullName);
    }*/

    selectedClient = true;

    var menu1 = document.getElementById("Menu-right1");
    var menu2 = document.getElementById("ClientSelection-Menu-right");

    menu1.style.display = "none";
    menu2.style.display = "block";

    var clientElements = document.getElementsByClassName("ClientSelection-ClientLink");
    for (let i = 0; i < clientElements.length; i++) {
      clientElements[i].style.color = null;
    }

    event.currentTarget.setAttribute("style", "color:blue !important");
  }

  function confirmClient() {
    localStorage.setItem("clientName", clientName);
    localStorage.setItem("clientUserId", clientUserId);
    localStorage.setItem("clientEmail", clientEmail);
    localStorage.setItem("clientUsername", clientUsername);
    localStorage.setItem("clientEulaAccepted", clientEulaAccepted);
    localStorage.setItem("clientExpires", clientExpires);

    localStorage.setItem("selectedClientName", clientName);
    localStorage.setItem("selectedClientEmail", clientEmail);
    localStorage.setItem("selectedClientUsername", clientUsername);
    localStorage.setItem("selectedClientUserId", clientUserId);
  }

  function navigateToRecipes(navigate) {
    localStorage.setItem("clientName", clientName);
    localStorage.setItem("clientUserId", clientUserId);
    localStorage.setItem("clientEmail", clientEmail);
    localStorage.setItem("clientUsername", clientUsername);
    localStorage.setItem("clientEulaAccepted", clientEulaAccepted);
    localStorage.setItem("clientExpires", clientExpires);

    localStorage.setItem("selectedClientName", clientName);
    localStorage.setItem("selectedClientEmail", clientEmail);
    localStorage.setItem("selectedClientUsername", clientUsername);
    localStorage.setItem("selectedClientUserId", clientUserId);

    setTimeout( function() {
      navigate("/recipes");
    }, 300);
    window.location.reload();
  }

  function setClient(element) {
    var clientFullName = element.innerHTML;

    clientSearched = true;

    setClientName(clientFullName);
    setClientUserId(element.getAttribute("data-user-id"));

    if ( element.getAttribute("data-user-email") !== null ) {
      setClientEmail(element.getAttribute("data-user-email"));
    }
    else {
      setClientUsername(element.getAttribute("data-user-username"));
      setClientEmail(null);
    }

    setClientActivated(element.getAttribute("data-user-activated"));
    setClientDeviceLock(element.getAttribute("data-user-device-lock"));
    localStorage.setItem("selectedClientDeviceLock", element.getAttribute("data-user-device-lock"));

    localStorage.setItem("selectedClientName", clientFullName);
    localStorage.setItem("selectedClientEmail", element.getAttribute("data-user-email"));
    localStorage.setItem("selectedClientUsername", element.getAttribute("data-user-username"));
    localStorage.setItem("selectedClientUserId", element.getAttribute("data-user-id"));
    localStorage.setItem("selectedClientLocale", element.getAttribute("data-user-locale"));
    localStorage.setItem("selectedClientOrgs", element.getAttribute("data-user-orgs"));
    localStorage.setItem("clientActivated", element.getAttribute("data-user-activated"));
    localStorage.setItem("selectedClientTwoStepVerified", element.getAttribute("data-user-twostep"));

    var settings = element.getAttribute("data-user-settings");

    if (settings !== null && settings.substring(settings.indexOf("[") + 1, settings.indexOf("[") + 2) === '"') {
      localStorage.setItem("selectedClientSettingsPros", settings.substring(settings.indexOf("[") + 1, settings.indexOf("]")).replaceAll('"', ""));
    }

    var restrictedRecipesIndex = settings.indexOf("RestrictToRecipes");

    if (settings !== null && restrictedRecipesIndex !== -1) {
      localStorage.setItem("selectedClientRestrictToRecipes", settings.substring(restrictedRecipesIndex).split(":")[1].split(",")[0]);
    }
    else {
      localStorage.setItem("selectedClientRestrictToRecipes", false);
    }

    if (element.getAttribute("data-user-eula") !== null) {
      localStorage.setItem("clientEulaAccepted", element.getAttribute("data-user-eula").split("T")[0]);
      setClientEulaAccepted(element.getAttribute("data-user-eula").split("T")[0]);
    }
    else {
      localStorage.setItem("clientEulaAccepted", t("local_not_activated"));
      setClientEulaAccepted(t("local_not_activated"));
    }

    if (element.getAttribute("data-user-expires") !== null) {
      localStorage.setItem("clientExpires", checkDate(element.getAttribute("data-user-expires")));
      setClientExpires(checkDate(element.getAttribute("data-user-expires")));
      localStorage.setItem("selectedClientExpires", checkDate(element.getAttribute("data-user-expires")));
    }
    else {
      localStorage.setItem("clientExpires", t("local_unlimited"));
      setClientExpires(t("local_unlimited"));
    }

    /*var whiteSpaceLocation = clientFullName.search(/\s/);

    if (whiteSpaceLocation !== -1) {
      var lastSpaceIndex = clientFullName.lastIndexOf(" ");

      setClientFirstName(clientFullName.split(" ")[0]);
      setClientLastName(clientFullName.substr(lastSpaceIndex));
    }
    else {
      setClientFirstName(clientFullName);
    }*/

    var menu1 = document.getElementById("Menu-right1");
    var menu2 = document.getElementById("ClientSelection-Menu-right");

    menu1.style.display = "none";
    menu2.style.display = "block";
  }

  function searchClients(event) {
    var clientElements = document.getElementsByClassName("ClientSelection-ClientLink");
    var setFirstClient = false;

    for (let i = 0; i < clientElements.length; i++) {

      if (event.target.value.trim().length < 2 && clientElements[i].getAttribute("data-hidden") === "true") {
        clientElements[i].setAttribute("style", "display:block !important");
        clientElements[i].setAttribute("data-hidden", "false !important");
      }

      if (event.target.value.trim() !== "" && ( clientElements[i].innerHTML.toLowerCase().includes(event.target.value.trim().toLowerCase())
      || ( clientElements[i].getAttribute("data-user-email") !== null && clientElements[i].getAttribute("data-user-email").toLowerCase().includes(event.target.value.trim().toLowerCase()) ))) {
        clientElements[i].setAttribute("style", "color:blue !important");
        //clientElements[i].setAttribute("style", "display:block !important");
        clientElements[i].setAttribute("data-hidden", "false !important");
        if (setFirstClient === false) {
          setClient(clientElements[i]);
          setFirstClient = true;
        }
      }
      else if (event.target.value.trim() === "" && selectedClient === true && clientElements[i].innerHTML.toString() === localStorage.getItem("clientName")) {
        clientElements[i].setAttribute("style", "color:blue !important");
        setClient(clientElements[i]);
      }
      else if (event.target.value.trim().length >= 2) {
        clientElements[i].setAttribute("style", "display:none !important");
        clientElements[i].setAttribute("data-hidden", "true !important");
      }
      else {
        clientElements[i].setAttribute("style", "color:black !important");
      }
    }
  }

  async function sendPwdReset() {

    document.getElementById("overlay").style.display = "block";

    try {
      const response = await fetch(baseUrl + "/api/v1/login/reset?email=" + encodeURIComponent(clientEmail));
      console.log(response);

      if (response.status === 200) {
        confirmAlert(resetEmailSentOptions);
      }
      else {
        confirmAlert(resetEmailFailedOptions);
      }

      document.getElementById("overlay").style.display = "none";

    } catch (err) {
      document.getElementById("overlay").style.display = "none";

      const resetEmailFailedOptions2 = {
        title: 'Title',
        message: 'Message',
        buttons: [
          {
            label: 'Yes',
            onClick: () => alert('Click Yes')
          },
          {
            label: 'No',
            onClick: () => alert('Click No')
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ title, message, onClose }) =>
          <div className='custom-ui'>
            <h1>{t("local_failed_to_send_reset_email")} {err}</h1>
            <button className="confirmButton" onClick={onClose}>Ok</button>
          </div>,
        willUnmount: () => {}
      }

      confirmAlert(resetEmailFailedOptions2);
    }

  }

  const [clients, setClients] = useState([]);
  const [userCount, setUserCount] = useState(null);

  const fetchUserData = async () => {
    try {


      const response = await fetch(baseUrl + "/api/v1/organisation/" + org + "/users",
      {
        headers: { "Authorization": "Bearer " + token,
         "Auth-ForceAdminClientAccess": "1" },
      });

      console.log(response);

      if (response.status === 403) {
        confirmAlert(tokenExpiredOptions);
      }
      else {
        const data = await response.json();

        setUserCount(data.org_user_count);

        setClients(data.users.filter(filterClients));
      }

    } catch (err) {

      const userListingFailedOptions = {
        title: 'Title',
        message: 'Message',
        buttons: [
          {
            label: 'Yes',
            onClick: () => alert('Click Yes')
          },
          {
            label: 'No',
            onClick: () => alert('Click No')
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ title, message, onClose }) =>
          <div className='custom-ui'>
            <h1>{t("local_failed_to_list_users")} {err}</h1>
            <button className="confirmButton" onClick={onClose}>Ok</button>
          </div>,
        willUnmount: () => {}
      }

      confirmAlert(userListingFailedOptions);
    }
  }

  const [userOrgCount, setUserOrgCount] = useState([]);
  const [userOrg, setUserOrg] = useState([]);

  const fetchOrgData = async () => {

    try {

      const response = await fetch(baseUrl + "/api/v1/organisation/get?ids=" + org,
      {
        headers: { "Authorization": "Bearer " + token },
      });

      console.log(response);

      if (response.status === 403) {
        confirmAlert(tokenExpiredOptions);
      }
      else {
        const data = await response.json();

        setUserOrgCount(data.organisations[0].max_number_of_users);
        setUserOrg(data.organisations[0].name);
      }

    } catch (err) {

      const orgFetchFailedOptions = {
        title: 'Title',
        message: 'Message',
        buttons: [
          {
            label: 'Yes',
            onClick: () => alert('Click Yes')
          },
          {
            label: 'No',
            onClick: () => alert('Click No')
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ title, message, onClose }) =>
          <div className='custom-ui'>
            <h1>{t("local_failed_to_fetch_org_data")} {err}</h1>
            <button className="confirmButton" onClick={onClose}>Ok</button>
          </div>,
        willUnmount: () => {}
      }

      confirmAlert(orgFetchFailedOptions);
    }
  }

  const [role, setRole] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [username, setUsername] = useState(null);
  const [userExpires, setUserExpires] = useState(null);
  //const [org, setOrg] = useState(null);
  const [orgs, setOrgs] = useState(null);
  const [userSettingsIds, setUserSettingsIds] = useState(null);

  const checkUserData = async () => {
    try {
      const response = await fetch(baseUrl + "/api/v1/account/" + userId,
      {
        headers: { "Authorization": "Bearer " + token },
      });

      console.log(response);

      if (response.status === 403) {
        confirmAlert(tokenExpiredOptions);
      }
      else if (response.status === 200) {
        const data = await response.json();

        if (data.twostep !== true && ( data.secret !== null && data.secret !== "none" )) {
          localStorage.clear();
          localStorage.setItem("userLanguage", userLanguage);
          sessionStorage.clear();
          window.location.replace(window.location.origin);
          return;
        }

        if (showClients !== "true" && data.role !== "Pro") {
          window.location.replace(window.location.origin + "/account");
        }

        setRole(data.role);
        setUserEmail(data.email);
        setUsername(data.full_name);
        setUserExpires(data.expires);
        //setOrg(data.orgs[0]);
        setOrgs(data.orgs.toString());

        var settings = data.settings;

        if (settings !== null && settings.substring(settings.indexOf("[") + 1, settings.indexOf("[") + 2) === '"') {
          setUserSettingsIds(settings.substring(settings.indexOf("[") + 1, settings.indexOf("]")).replaceAll('"', ""));
        }
      }
      else {
        confirmAlert(wrongUserDataOptions);
      }

    } catch (err) {

      const accountFetchFailedOptions = {
        title: 'Title',
        message: 'Message',
        buttons: [
          {
            label: 'Yes',
            onClick: () => alert('Click Yes')
          },
          {
            label: 'No',
            onClick: () => alert('Click No')
          }
        ],
        childrenElement: () => <div />,
        customUI: ({ title, message, onClose }) =>
          <div className='custom-ui'>
            <h1>{t("local_failed_to_fetch_account_data")} {err}</h1>
            <button className="confirmButton" onClick={onClose}>Ok</button>
          </div>,
        willUnmount: () => {}
      }

      confirmAlert(accountFetchFailedOptions);
    }
  }

  const fetchData = async () => {
    document.getElementById("overlay").style.display = "block";
    await checkUserData();
    await fetchUserData();
    await fetchOrgData();
    document.getElementById("overlay").style.display = "none";
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();

  const navbarContext = useContext(NavbarContext);
  navbarContext.setNavbarStyle(1);

  return (
    <div className="ClientSelection-container">
      {<Navbar />}
      <div className="CrumbPathDiv">
        <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToMenu(navigate)}>
          {t("local_button_ingame_menu")}
        </button>
        <span> – </span>
        { createOrgClient === "true" && (
          <React.Fragment>
            <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToOrganisation(navigate)}>
              {t("local_organisation")}
            </button>
            <span> – </span>
          </React.Fragment>
        )}
        <button className="CrumbPath-link btn btn-link btn-link-nopad" onClick={() => navigateToClientSelection(navigate)}>
          {t("local_clients_list")}
        </button>
      </div>
      <div className="ClientSelection-Menu-container">
        <div className="ClientSelection-Menu-left">
          <input type="text" id="MenuSearchbar" onChange={searchClients} /> <br />
          <strong className="ClientSelection-title">{t("local_clients")}</strong>
          <span>
            <a className="CreateClient" href="./createoreditclient" id="CreateOrEditClientLink" onClick={(event) => checkClient(event, setNavigateContext)}>{t("local_create_new")}</a>
          </span>
          <div className="ClientSelection-items-container">
            { clients.length > 0 && (
              <React.Fragment>
                <strong className="ClientSelection-clientorg">{t("local_organisation")}: </strong>
                <strong className="ClientSelection-clientorg2">{userOrg}</strong> <br /> <br />
                <span className="ClientSelection-clientcount">{t("local_user_count")}: {userCount} / {userOrgCount}</span> <br />
                <ul className="ClientSelection-clientlist">
                  { clients.map(client => (
                    <li>
                      { checkEndDate(client.expires) === true ? (
                        <span title={client.full_name}>
                          <button className="ClientSelection-ClientLink btn btn-link btn-link-nopad" data-user-username={client.login_name} data-user-twostep={client.twostep} data-user-device-lock={client.device_lock} data-user-activated={client.activated} data-user-eula={client.eula_accepted} data-user-expires={client.expires} data-user-id={client.user_id} data-user-settings={client.settings} data-user-email={client.email} data-user-locale={client.locale} data-user-orgs={client.orgs} onClick={saveClient}>
                            {client.full_name}
                          </button>
                        </span>
                      ) : (
                        <span title={client.full_name}>
                          <button className="ClientSelection-ClientLink Expired-ClientLink btn btn-link btn-link-nopad" data-user-username={client.login_name} data-user-twostep={client.twostep} data-user-device-lock={client.device_lock} data-user-activated={client.activated} data-user-eula={client.eula_accepted} data-user-expires={client.expires} data-user-id={client.user_id} data-user-settings={client.settings} data-user-email={client.email} data-user-locale={client.locale} data-user-orgs={client.orgs} onClick={saveClient}>
                            {client.full_name}
                          </button>
                        </span>
                      )}
                      <br />
                    </li>
                  ))}
                </ul>
              </React.Fragment>
            )}
          </div>
          <p className="ClientSelection-Menu-left-footer">{t("local_client_selection_footer")}</p>
        </div>
        <div className="Menu-right1" id="Menu-right1">
          <span className="ClientSelection-right-menu-header">{t("local_search_by_client")}</span>
          <span className="ClientSelection-line"></span>
        </div>
        <div className="ClientSelection-Menu-right" id="ClientSelection-Menu-right">
          <div className="Menu-right-top">
            <table className="Menu-right-top-table4">
              <tr>
                <td className="Menu-right-top-header-upper csmrth-client ClientSelection-clientname">{t("local_client")}: <strong>{clientName}</strong></td>
                <td><a className="CNC-link Menu-right-top-header-upper csmrth-confirm" id="confirmLink" onClick={confirmClient} href="./client">{t("local_confirm_client")}</a></td>
              </tr>
            </table>
            <table className="Menu-right-top-table2">
              <tr>
                <td className="Menu-right-top-header csmrth-general"><a className="Menu-right-top-header-link menu-header-link-selected csmrth-general-link" href="./client">{t("local_general")}</a></td>
                <td className="Menu-right-top-header csmrth-recipe"><button className="Menu-right-top-header-link btn btn-link btn-link-nopad" onClick={() => navigateToRecipes(navigate)}>
                  <a className="Menu-right-top-header-link2 navigateRecipesHeader csmrth-recipe-link" href="./recipes">{t("local_recipes")}</a>
                </button></td>
                {/*<td className="Menu-right-top-header csmrth-progress"><a className="Menu-right-top-header-link" onClick={confirmClient} href="./progress">{t("local_progress")}</a></td>*/}
              </tr>
            </table>
          </div>
          <span className="Menu-line"></span>
          <div className="Menu-right-bottom-title">
            <table className="Menu-right-bottom-table-upper">
              <th className="Clients-Menu-right-bottom-header1">{t("local_client_user_details")}</th>
              {/*<td className="Clients-Menu-right-bottom-header2">Status:</td>
              <td className="Clients-Menu-right-bottom-header3">Active</td>*/}
            </table>
          </div>
          <div className="Clients-Menu-right-bottom">
            <table className="Menu-right-bottom-table-lower">
              {/*<tr>
                <td className="ud1-row1-item1">Title</td>
                <td className="ud1-row2-item1">Unknown</td>
              </tr>*/}
              {/*<tr>
                <td className="ud1-row1-item2">First name</td>
                <td className="ud1-row2-item2">{clientFirstName}</td>
              </tr>
              <tr>
                <td className="ud1-row1-item3">Last name</td>
                <td className="ud1-row2-item3">{clientLastName}</td>
              </tr>*/}
              <tr className="clientFlexRow">
                <td className="ud1-row1-item1">{t("local_full_name")}</td>
                <td className="ud1-row2-item1 ClientSelection-clientname">{clientName}</td>
              </tr>
              {/*<tr>
                <td className="ud1-row1-item4">Date of birth</td>
                <td className="ud1-row2-item4">Unknown</td>
              </tr>
              <tr>
                <td className="ud1-row1-item5">Gender</td>
                <td className="ud1-row2-item5">Unknown</td>
              </tr>*/}
              <tr>
                <br />
              </tr>
              <tr className="clientFlexRow">
                <td className="ud2-row1-item1">{t("local_email_username")}</td>
                { (clientEmail === null || clientEmail === "null")  ? (
                  <td className="ud2-row2-item1 btn btn-link btn-link-nopad">{clientUsername}</td>
                ) : (
                  <td className="ud2-row2-item1 btn btn-link btn-link-nopad">{clientEmail}</td>
                )}
              </tr>
              <tr className="clientFlexRow">
                <td className="ud2-row1-item2">{t("local_password")}</td>
                <td><button className="ud2-row2-item2 underline btn btn-link btn-link-nopad" onClick={sendPwdReset}>
                  {t("local_reset_your_password2")}
                </button></td>
              </tr>
              {/*<tr>
                <br />
              </tr>
              <tr>
                <td className="ud3-row1-item1">Area of Interest</td>
                <td className="ud3-row2-item1">Unknown</td>
              </tr>*/}
              <tr>
                <br />
              </tr>
              <tr className="clientFlexRow">
                <td className="ud3-row1-item2">{t("local_activated_by")}</td>
                <td className="ud3-row2-item2">{t("local_activation_date")}</td>
                <td className="ud3-row3-item1">{t("local_release_date")}</td>
              </tr>
              <tr>
                <br />
              </tr>
              <tr className="clientFlexRow">
                <td className="ud3-row1-item3 underline">{clientActivated}</td>
                <td className="ud3-row2-item3">{clientEulaAccepted}</td>
                <td className="ud3-row3-item2 underline">{clientExpires}</td>
              </tr>
              <tr>
                <br />
              </tr>
              <tr>
                <td><button className="editClientLink btn btn-link btn-link-nopad" onClick={() => editClient(navigate, setNavigateContext)}>
                  {t("local_edit_client")}
                </button></td>
              </tr>
              <tr>
                <br />
              </tr>
              <tr>
                <td><button className="btn btn-link btn-link-nopad" onClick={() => navigateToRecipes(navigate)}>
                  <a className="editRecipesLink" href="./recipes">{t("local_edit_recipes")}</a>
                </button></td>
              </tr>
              <tr>
                <br />
              </tr>
              <tr>
                <td><button className="deleteClientLink btn btn-link btn-link-nopad" onClick={() => deleteClient(navigate, setNavigateContext)}>
                  {t("local_delete_client")}
                </button></td>
              </tr>
              <tr>
                <br />
              </tr>
              <tr>
                <td><button className="assignProsLink btn btn-link btn-link-nopad" onClick={() => assignPros(navigate, setNavigateContext)}>
                  {t("local_assign_pros")}
                </button></td>
              </tr>
              { clientDeviceLock === "true" && (
                <React.Fragment>
                  <tr>
                    <br />
                  </tr>
                  <tr>
                    <td><button className="releaseDeviceLockLink btn btn-link btn-link-nopad" onClick={() => confirmDeviceLockRelease()}>
                      {t("local_release_device_lock")}
                    </button></td>
                  </tr>
                </React.Fragment>
              )}
              <tr>
                <br />
              </tr>
              <tr>
                <td><button className="searchResultsLink btn btn-link btn-link-nopad" onClick={() => searchResultRecipe(navigate, setNavigateContext)}>
                  {t("local_view_results_by_recipe")}
                </button></td>
              </tr>
              <tr>
                <br />
              </tr>
              <tr>
                <td><button className="searchResultsLink btn btn-link btn-link-nopad" onClick={() => searchResultGame(navigate, setNavigateContext)}>
                  {t("local_view_results_by_game")}
                </button></td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div id="overlay">
        <div className="Loading-icon-div">
          <img src={require("../images/loading-icon.png")} className="Loading-icon" alt = "Loading..." border = "0"/>
        </div>
      </div>

    </div>
  )
}

export default ClientSelection;
